<template>
  <v-menu offset-y
   bottom
   :left="sidebar"
   origin="top center"
   transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        block
        outline
        color="#1E88E5"
        v-on="on"
        class="costa-border"
      >
        {{ $i18n.t('contact') }}
      </v-btn>
    </template>
    <v-list>
      <v-list-tile
        v-for="(item, index) in contactOptions"
        :key="index"
      >
        <v-list-tile-action>
          <a :href="item.link" class="normal-link" target="_blank">
            <v-icon>{{ item.icon }}</v-icon>
          </a>
        </v-list-tile-action>
        <v-list-tile-title>
          <a :href="item.link" class="normal-link" target="_blank">
            {{ $i18n.t(item.title_translation) + (item.colon ? ':' : '') }}
            {{ item.title }}
          </a>
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-title style="text-align: center;">
          <v-icon small>fa-times</v-icon>
        </v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'ContactUsMenu',

  props: {
    contactOptions: {
      type: Array,
      default: () => []
    },

sidebar: {
      type: Boolean,
      default: false
    }
  },

  computed: {

  }
}
</script>
